import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cloudinary from 'cloudinary-core';

import RemoteDataPoint from './RemoteDataPoint';
import { CDN_PROVIDERS } from '../../constants/cdnConstants';
import { getRemotePartialPath } from './MultiCdnUtils';

import globalData from './GlobalData.tsv';

const getData = function (city, path) {
    // locationData is an array with the data for all CDN providers
    const locationData = globalData.filter(dataUnit => dataUnit.city === city && dataUnit.path === path);
    if (locationData && locationData.length > 0) {
        let fastestProviderIndex = Object.keys(CDN_PROVIDERS).length - 1; // Cloudinary Multi-CDN
        locationData.forEach((cdnProviderData, index) => {
            if (parseFloat(cdnProviderData.median) < parseFloat(locationData[fastestProviderIndex].median)) {
                fastestProviderIndex = index;
            }
        });
        locationData[fastestProviderIndex].isFastest = true;
    }
    return locationData;
};

class CityRow extends Component {

    render() {
        const {
            country,
            city,
            countryCode,
            countryLabel,
            image,
            transformation,
            cdnStats
        } = this.props;
        const path = getRemotePartialPath(image, transformation, city);
        const cityData = getData(city, path);
        // Compariosn without coersion by design - to allow countryLabel to be an empty string
        const countryName = countryLabel != undefined ? countryLabel : country;
        let separator = ',';
        if (!countryName) {
            separator = '';
        }
        return (
            <tr>
                <td>
                    <span className={'flag-icon flag-icon-' + countryCode} /> {city}{separator} {countryName}
                </td>
                {
                    Object.keys(CDN_PROVIDERS).map((cdnKey, i) =>
                        <td
                            className="text-center"
                            key={i}>
                            <RemoteDataPoint dataPointStats={
                                cityData && cityData.length > 0 ? cityData.reduce((accumulator, cdnProviderData) => {
                                    if (cdnProviderData.host.indexOf(`idemo-${cdnKey}`) > -1) {
                                        return cdnProviderData;
                                    }
                                    return accumulator;
                                }) : { mean: 'N/A', median: 'N/A', p10: 'N/A', p90: 'N/A' }
                            } />
                        </td>
                    )
                }
            </tr>
        );
    }
}

CityRow.PropTypes = {
    country: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    countryLabel: PropTypes.string,
    image: PropTypes.string.isRequired,
    transformation: PropTypes.object
};

export default connect()(CityRow);



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/CityRow.js
 **/